<template>
  <div>
    <div class="works-list__container" style="position: relative" v-show="works.length>0">
      <div class="grid-sizer"/>
      <div class="masonry">
        <works-item v-for="work in works"
                    :wimg="400" :work="work" :key="work.work_id"
                    :is_mark_work_pro="is_mark_work_pro"/>
      </div>
    </div>

    <div v-show="works.length==0" class="placeholder-box">
      <div class="placeholder-image">
        <img :src="plceholder_src" style="width: 361px"/>
      </div>

      <div class="placeholder-text">
        {{ $t("message.NothingToShow") }}
      </div>
    </div>
  </div>
</template>

<script>
//используется на субдоменах

  import WorksItem from "./WorksItem";
  import WorksListMix from "./WorksListMix";
  import WorksComputedMix from "../WorksComputedMix";

  export default {
    components: { WorksItem },
    name: 'works-list',
    mixins: [WorksListMix, WorksComputedMix],
  }
</script>



// WEBPACK FOOTER //
// src/components/list/WorksList.vue